export const ObjectTypes = {
  line: 'line',
  rectangle: 'rectangle',
  circle: 'circle',
  block: 'block',
  text: 'text',
  cpoint: 'cpoint',

  // networks
  pipe: 'pipe',
  duct: 'duct',

  // env
  water: 'water',
  air: 'air',

  // local resistances
  elbow: 'elbow',
  elbowBlock: 'elbowBlock',
  tee: 'tee',

  // networks segment shapes
  rect: 'rect',
  round: 'round',

  networkSketch: 'networkSketch',

  // тип тройника
  exhaust: 'exhaust',
  supply: 'supply',

  // направление потока в тройниках (на проход или на поворот)
  pass: 'pass',
  turn: 'turn',

  // типы формы тройников
  simpleTee: 'simpleTee',
  simpleElbow: 'simpleElbow',


}

export const DrawingModes = {
  line: 'line',
  rectangle: 'rectangle',
  circle: 'circle',
  move: 'move',
  copy: 'copy',
  edit: 'edit',
  rotate: 'rotate',
  mirror: 'mirror',
  select: 'select',
  networkSketch: 'networkSketch',
  duct: 'duct',
  pipe: 'pipe',
}